import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  selectedItem: string;
  constructor(private router: Router) { }

  ngOnInit() {
    this.selectedItem = this.router.url.substring(1);
  }
  
  navigate(event): void {
    this.selectedItem = event.target.innerHTML.toLowerCase();
  }
}
